<template>
  <div class="address_show_all">
    <div class="pickup_address" v-if="pickupAddress">
      <img
        src="@/assets/order/icon_location@2x.png"
        alt=""
        class="icon_loaction"
      />
      <div class="selectionstyle3_all">
        <!-- 第一行：自提门店名称 与 联系客服 -->
        <div class="pickup_header_row">
          <div class="pickup_store_name">
            {{ pickupAddress.areaName || pickupAddress.name }}
          </div>
          <span class="contact_service" @click="contactService">联系客服</span>
        </div>

        <!-- 第二行：提货地址标签 -->
        <div class="pickup_address_label">提货地址：</div>

        <!-- 第三行：详细地址 -->
        <div class="pickup_store_address">
          {{ pickupAddress.addressLine || pickupAddress.address }}
        </div>

        <!-- 第四行：联系电话 -->
        <div class="pickup_store_phone">
          联系电话：{{ pickupAddress.phone || "" }}
        </div>
      </div>
    </div>
    <div class="selectionstyle3_all" v-else>
      <div class="pickup_store_name">暂无可用自提门店</div>
    </div>
    <img src="@/assets/common/address_line@2x.png" alt="" class="add_line" />
  </div>
</template>

<script>
export default {
  name: "PickupAddressCard",
  props: {
    pickupAddress: {
      type: Object,
      default: null
    }
  },
  methods: {
    contactService() {
      this.$emit("contactService");
    }
  }
};
</script>

<style lang="less" scoped>
.address_show_all {
  background-color: white;
  position: relative;
  text-align: left;
  overflow: hidden;

  .pickup_address {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: flex-start;
  }

  .icon_loaction {
    width: 16px;
    margin: 14px 12px 0;
    vertical-align: middle;
  }

  .selectionstyle3_all {
    padding: 16px 15px 15px 15px;
    flex: 1;

    .pickup_header_row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;

      .contact_service {
        font-size: 14px;
        color: #bf9264;
        font-weight: 500;
        cursor: pointer;
      }
    }

    .pickup_store_name {
      font-size: 18px;
      font-weight: 600;
      color: #000;
    }

    .pickup_address_label {
      font-size: 14px;
      font-weight: 500;
      color: #000;
      margin-top: 10px;
      margin-bottom: 4px;
    }

    .pickup_store_address {
      font-size: 13px;
      color: rgba(0, 0, 0, 0.65);
      line-height: 18px;
      margin-bottom: 4px;
    }

    .pickup_store_phone {
      font-size: 13px;
      color: rgba(0, 0, 0, 0.65);
    }
  }

  .add_line {
    position: absolute;
    bottom: 0px;
    left: 0;
    right: 0;
    display: block;
    width: 100%;
    height: 3px;
  }
}
</style>
